import { useNuxtApp } from 'nuxt/app';
import { productPackageUnitSizeStr2 } from '~~/common/utils/variant';

export function useProductPackageUnitSizeStr2 () {
  const {
    $awt,
    $i18n,
  } = useNuxtApp();
  return function (arg: Omit<Parameters<typeof productPackageUnitSizeStr2>[0], '$awt' | 'locale'>) {
    const locale = $i18n.locale.value;
    return productPackageUnitSizeStr2({
      ...arg,
      locale,
      $awt,
    });
  };
}
